module.exports = __webpack_public_path__ + "img/title.9cc3dea8.png";